import React, { useState, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { MESSAGE, USER_GENDER_DROPDOWN } from "../../../constant";
import "../DailyQuotes/dailyQuotes.css";
import "../../UserManagement/UserManagementClinicianDetails/userManagementClinicianDetails.css";
import AddModalHoc from "../AddModalHoc/addModalHoc";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreator from "../../../modules/actions";
import moment from "moment";
import { validateChar, validateTextField } from "../../../utils/validations";
import TextField from "../textField";
import { rename, replace, status } from "../../../utils/rename";
import DateField from "../dateField";
import ContentButton from "../contentButton";
import ImageUpload from "../ImageUpload";
import { toast } from "react-toastify";
import { components } from "react-select";
import { clone } from "lodash";
import MultiSelect from "../../UserManagement/multiSelect";

const MenuList = props => {
  return (
    <components.MenuList {...props}>
      <div className="select-style">
        You can select multiple options from the list of hospitals{" "}
      </div>
      {props.children}
    </components.MenuList>
  );
};

const Option = props => {
  return (
    <components.Option {...props}>
      <div>
        {props.children}
        <input
          className="option-custom-input"
          type="checkbox"
          checked={props.isSelected}
          onChange={e => null}
        ></input>
      </div>
    </components.Option>
  );
};

const AddGlossary = props => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [termInvalid, setTermInvalid] = useState(false);
  const [meaningInvalid, setMeaningInvalid] = useState(false);
  const [submittedOnce, setSubmittedOnce] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hospitalInvalid, setHospitalInvalid] = useState(false);
  const [options, setOptions] = useState();

  const [data, setData] = useState({
    term: "",
    meaning: "",
    images: [],
    hospital: [],
    hospitalList: [],
  });

  useEffect(() => {
    if (props.isEdit) {
      let hospitalArray = [];
      let hospitalIdArray = [];
      if (
        props.glossary.hospital_detail &&
        props.glossary.hospital_detail.length > 0 &&
        options?.length > 0
      ) {
        props.glossary.hospital_detail &&
          props.glossary.hospital_detail.forEach(hospital => {
            options.map(option => {
              if (option.value === hospital.id) {
                hospitalArray.push(option);
                hospitalIdArray.push(option.value);
              }
            });
          });
      }
      setData({
        term: props.glossary.cellOne,
        meaning: props.glossary.meaning ? props.glossary.meaning : "",
        images: props.glossary.picture ? props.glossary.picture : [],
        hospitalList:
          hospitalArray.length === options?.length - 1
            ? [...hospitalArray, { label: "All", value: "all" }]
            : hospitalArray,
        hospital: hospitalIdArray,
      });
    }else{
      setData({
        ...data,
        hospital : props.userRole.includes("ADMIN") ? data.hospital : [props.hospitalDetails.id]
      })
    }
  }, [options]);

  useEffect(() => {
    props.getFullHospitals();
  }, []);

  useEffect(() => {
    setOptions(
      [
        ...rename(props.fullHospitals.data, "value", "label", "id", "name"),
        { label: "All", value: "all" },
      ]
    );
  }, [props.fullHospitals.data]);

  const isIncludingString = (string, option) => {
    let result = false;
    if (
      !string ||
      option.label.toString().includes(string) ||
      option.value.toString().includes(string)
    ) {
      result = true;
    }
    return result;
  };

  const setHospital = (opt, { option }) => {
    let newOpts = opt;
    let string = newOpts.value;
    let hospitalArray = [];
    let hospitalDetailsArray = [];
    if (data.hospital?.length === 0) {
      data.hospitalList &&
        data.hospitalList.map(hopital => {
          hospitalArray.push(Number(hopital.id));
          hospitalDetailsArray.push(hopital);
        });
    }
    if (
      data.hospitalList?.pop()?.label === "All" &&
      option &&
      option.value === "all"
    ) {
      hospitalArray = [];
      hospitalDetailsArray = [];
    } else if (option && option.value === "all") {
      let filteredOptions = clone(options);
      filteredOptions = filteredOptions.filter(
        filteredOption =>
          isIncludingString(string, filteredOption) &&
          !newOpts.includes(filteredOption)
      );
      newOpts = newOpts
        .concat(filteredOptions)
        .filter(newOpt => newOpt.value !== "all");
      newOpts.map(val => {
        hospitalArray.push(Number(val.value));
        hospitalDetailsArray.push(val);
      });
    } else {
      opt.map(obj => {
        hospitalArray.push(Number(obj.value));
        hospitalDetailsArray.push(obj);
      });
    }
    setHospitalInvalid(false);
    const is_same = () => {
      let count = 0;
      hospitalDetailsArray.map(obj => {
        if (options.includes(obj)) {
          count = count + 1;
        }
      });
      return count;
    };
    if (is_same() === options.length - 1) {
      setData({
        ...data,
        hospital: [...new Set(hospitalArray)],
        hospitalList: [
          ...new Set([...hospitalDetailsArray, { label: "All", value: "all" }]),
        ],
      });
    } else {
      hospitalDetailsArray = hospitalDetailsArray.filter(
        item => item.value !== "all"
      );

      setData({
        ...data,
        hospital: [...new Set(hospitalArray)],
        hospitalList: [...new Set(hospitalDetailsArray)],
      });
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    setSubmittedOnce(true);
    let validatedTerm = validateChar(data.term);
    let validatedTextField = validateTextField(data.meaning);
    let validatedHospital = data.hospital.length > 0;
    if (!validatedTerm) {
      setTermInvalid(true);
    }
    if (!validatedTextField) {
      setMeaningInvalid(true);
    }
    if (!validatedHospital) {
      setHospitalInvalid(true);
    }
    if (!validatedTextField || !validatedTerm || !validatedHospital) {
      return;
    }

    if (loading) {
      toast.error(MESSAGE.UPLOAD_PROGRESS, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    props.toggleMainLoader(true);
    props.addGlossary({
      user: props.user.idToken,
      term: data.term,
      meaning: data.meaning,
      picture: data.images.length ? data.images : null,
      scheduled_date: selectedDate
        ? moment(selectedDate).format("YYYY-MM-DD")
        : "",
      status: status(selectedDate),
      hospital: data.hospital,
    });
  };

  const handleUpdate = e => {
    e.preventDefault();
    setSubmittedOnce(true);
    let validatedTerm = validateChar(data.term);
    let validatedTextField = validateTextField(data.meaning);
    let validatedHospital = data.hospital.length > 0;
    if (!validatedTerm) {
      setTermInvalid(true);
    }
    if (!validatedTextField) {
      setMeaningInvalid(true);
    }
    if (!validatedHospital) {
      setHospitalInvalid(true);
    }
    if (!validatedTextField || !validatedTerm || !validatedHospital) {
      return;
    }
    if (loading) {
      toast.error(MESSAGE.UPLOAD_PROGRESS, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    props.toggleMainLoader(true);
    props.updateGlossary(props.glossary.id, {
      user: props.glossary.user_id,
      term: data.term,
      meaning: data.meaning,
      picture: data.images.length ? data.images : null,
      hospital: data.hospital,
    });
  };

  const handleImageDelete = (e, index) => {
    e.preventDefault();
    const arr = [...data.images];
    arr.splice(index, 1);
    setData({ ...data, images: arr });
  };

  const styles = {
    control: (base, state) => ({
      ...base,
      border: submittedOnce
        ? data.hospital.length === 0
          ? "1px solid #eb5757"
          : 0
        : 0,
      // This line disable the blue border
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgb(0 123 255 / 25%)" : 0,
      "&:hover": {
        border: submittedOnce
          ? data.hospital.length === 0
            ? "1px solid #eb5757"
            : 0
          : 0,
      },
    }),
    valueContainer: (base, state) => ({
      ...base,
      width: "100%",
      maxWidth: "552px",
      height: "60px",
      backgroundColor: "#f4f4f4",
      borderRadius: "8px",
      boxSizing: "border-box",
      border: "none",
      backgroundImage: `url(${USER_GENDER_DROPDOWN})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "95% 50%",
    }),

    indicatorsContainer: (base, state) => ({
      ...base,
      display: "none",

      backgroundColor: "#f4f4f4",

      border: "none",
      backgroundImage: "none",
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "14px",
      color: "#5b616b",
      outline: "none",
    }),
    option: (base, state) => ({
      ...base,
      borderBottom: "1px solid #AEB0B5",
      color: "#455674",
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "24px",
      paddingTop: "16px",
      paddingBottom: "16px",
      backgroundColor: "none",
      paddingLeft: "20px",
    }),
  };

  return (
    <>
      <Form noValidate>
        {props.userRole.includes("ADMIN") ?
          <Row style={{ marginTop: "24px" }}>
          <Col>
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="parent-name">
                Hospital<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <MultiSelect
                multi={true}
                placeholder={"Select Hospital"}
                options={options}
                styles={styles}
                components={{ MenuList, Option }}
                className="select-hospital-class"
                hideSelectedOptions={false}
                closeMenuOnSelect={false}
                onChange={setHospital}
                value={data.hospitalList}
              />
              {submittedOnce ? (
                hospitalInvalid ? (
                  <p className="clinician-invalid">Please choose a category</p>
                ) : null
              ) : null}
            </Form.Group>
          </Col>
        </Row> : 
        
        <Row style={{ marginTop: "24px" }}>
          <Col>
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="parent-name">
                Hospital<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <MultiSelect
                multi={true}
                placeholder={"Select Hospital"}
                options={options}
                styles={styles}
                className="select-hospital-class"
                hideSelectedOptions={false}
                closeMenuOnSelect={false}
                value={[{"label":props.hospitalDetails.name, "value":props.hospitalDetails.name}]}
                disabled = {true}
              />
              {submittedOnce ? (
                hospitalInvalid ? (
                  <p className="clinician-invalid">Please choose a category</p>
                ) : null
              ) : null}
            </Form.Group>
          </Col>
        </Row>
        }
        <Row>
          <Col style={{ paddingRight: "10px" }}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="modal-content-label">
                Glossary Term<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Glossary Term"
                className="input-field-content"
                value={data.term}
                maxLength={100}
                onChange={e => {
                  setData({ ...data, term: e.target.value });
                  submittedOnce
                    ? setTermInvalid(!validateChar(e.target.value))
                    : setTermInvalid(false);
                }}
                isInvalid={termInvalid}
              />
              <div style={{ marginBottom: "10px" }}>
                <div className="chracter-remain-title">
                  {100 - data.term.length}/100 Characters{" "}
                </div>
              </div>
              <Form.Control.Feedback
                type="invalid"
                className="clinician-invalid"
              >
                {MESSAGE.TERM_INVALID}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col></Col>
        </Row>

        <TextField
          label={"Glossary Term Meaning"}
          className={"text-field-content"}
          labelClassName={"textfield-content-label-glossary"}
          isInvalid={meaningInvalid}
          value={data.meaning}
          max={"2000"}
          onChange={e => {
            setData({
              ...data,
              meaning: e.target.value,
            });
            submittedOnce
              ? setMeaningInvalid(
                !validateTextField(replace(e.target.value)) ? true : false
              )
              : setMeaningInvalid(false);
          }}
          message={MESSAGE.MEANING_INVALID}
        />
        <div style={{ marginBottom: "10px" }}>
          <div className="chracter-remain">
            {2000 - data.meaning.length}/2000 Characters{" "}
          </div>
        </div>
        <ImageUpload
          title={"Add Images (Optional)"}
          optional={true}
          data={data}
          setData={res => {
            setData({ ...data, images: [...data.images, res.location] });
          }}
          handleMultiImageDelete={handleImageDelete}
          loading={loading}
          setLoading={setLoading}
        />
        {submittedOnce ? (
          !data.images ? (
            <p className="clinician-invalid">Please upload valid image</p>
          ) : null
        ) : (
          <Form.Text className="text-muted" style={{ marginTop: "-10px" }}>
            **Please Add JPG or PNG. Pictures should be aligned vertically. If posted horizontal, pictures will rotate when exported.
          </Form.Text>
        )}
        <Row>
          <Col>
            {!props.isEdit ? (
              <DateField
                show={show}
                selectedDate={selectedDate}
                setShow={e => setShow(e.target.checked)}
                setSelectedDate={date => {
                  setSelectedDate(date);
                }}
              />
            ) : null}
          </Col>
          <Col className="mt-auto">
            <ContentButton
              onClick={props.isEdit ? handleUpdate : handleSubmit}
              title={props.isEdit ? "Update Glossary" : "Publish Glossary"}
              className={"podcast-button"}
            />
          </Col>
        </Row>
      </Form>
    </>
  );
};

const mapStateToProps = state => {
  try {
    return {
      user: state.user.profile,
      details: state.userManagementDetails.details,
      loader: state.loader.mainLoader,
      glossary: state.contentDetails,
      fullHospitals: state.fullHospitals,
      userRole: state.user.profile.role,
      hospitalDetails: state.hospitalDetails,
    };
  } catch (e) {
    console.log(e);
  }
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      reset: actionCreator.reset,
      addGlossary: actionCreator.addGlossary,
      toggleMainLoader: actionCreator.toggleMainLoader,
      updateGlossary: actionCreator.updateGlossary,
      getFullHospitals: actionCreator.getFullHospitals,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddModalHoc(AddGlossary));
